export default "__VITE_ASSET__D_Ep7a_Y__"